import { useSelectedDealer, useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { LOCATION_LICENSES_STORAGE_KEYS } from "modules/LocationLicenseOverview/storageKeys";
import { setPreference } from "utils/common";

export const useResetLocationLicensesDashboardFilters = () => {
  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();

  return {
    handleResetLocationLicensesDashboardFilters: () => {
      setPreference(LOCATION_LICENSES_STORAGE_KEYS.DealerPreference, selectedDealer);
      setPreference(LOCATION_LICENSES_STORAGE_KEYS.LocationPreference, selectedLocation);
      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.filters, { dealer: selectedDealer, location: selectedLocation });
    }
  };
};
